"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _isBetween = _interopRequireDefault(require("dayjs/plugin/isBetween"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dayjs["default"].extend(_isBetween["default"]);

var doRangesOverlap = function doRangesOverlap(from1, to1, from2, to2) {
  return (0, _dayjs["default"])(from1).isBetween(from2, to2, 'day', '[]') || (0, _dayjs["default"])(to1).isBetween(from2, to2, 'day', '[]') || (0, _dayjs["default"])(from2).isBetween(from1, to1, 'day', '[]') || (0, _dayjs["default"])(to2).isBetween(from1, to1, 'day', '[]');
};

var _default = doRangesOverlap;
exports["default"] = _default;